import React, { FC, HTMLAttributes, ReactNode } from 'react';

export interface TableMenuProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

export const TableMenu: FC<TableMenuProps> = ({
  children,
  ...rest
}: TableMenuProps) => {
  return (
    <div
      className="w-full border-b border-thryv-gray-light-400 p-[30px]"
      {...rest}
    >
      {children}
    </div>
  );
};
